import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SclAceTextRulesInterfaceService {

  constructor() {
  }


/////////

  syncEditBuffer(doc, fieldName, componentDefinition, _editor) {
    let content = doc[fieldName];
    if (componentDefinition.textFormat === 'raw-json') {
      try {
        content = JSON.parse(_editor.value);
      } catch (e) {}
    } else {
      content = _editor.value;
    }
    doc[fieldName] = content;
  }

  extractValuesToDoc(doc, fieldName, componentDefinition, _editor, tempKeys) {
    let text = _editor.value;
    if (componentDefinition.textFormat === 'json') {
      const editor = _editor.getEditor();
      const session = editor.session;
      const textValue = session.getValue();
      if (componentDefinition.storeToRoot) {
        if (textValue && textValue.length >= 6) {
          try {
            const json = JSON.parse(textValue);
            for (let i = 0; i < tempKeys.length; i++) {
                if (doc[tempKeys[i]]) {
                    delete doc[tempKeys[i]];
                }
            }
            // angular.forEach(json, function(bean, key) {
            //   this.tempKeys.push(key);
            //   this.doc[key] = bean;
            // });
            Object.keys(json).forEach(function(k){
              // console.log(k + ' - ' + obj[k]);
              this.tempKeys.push(k);
              this.doc[k] = json[k];
            });

          } catch (err) {}
        }
      }
      if (textValue) {
        text = JSON.stringify(textValue, undefined, 2);
      }
    } else if (componentDefinition.textFormat === 'raw-json') {
      doc[fieldName] = {};
      try {
        text = JSON.parse(text);
      } catch (err) {}
    }
    if (text !== '') {
      doc[fieldName] = text;
    }
}



/////////



}
